'use client'

import { useState, useRef, useEffect } from 'react'

import { Copy, ImageBox, Modal } from 'shared-components'

import Play from '../../images/play'

import s from './Video.module.sass'

function VideoSection({ video: _video = {} }: any) {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const videoRef = useRef<HTMLVideoElement>(null)

    const { pretitle: videoPretitle, title, copy, video, videoFile, videoPoster } = _video || {}

    useEffect(() => {
        if (isModalOpen && videoRef.current) {
            videoRef.current.play()
        } else {
            if (videoRef.current) {
                videoRef.current.currentTime = 0
            }
            videoRef.current?.pause()
        }
    }, [isModalOpen])

    const videoUrl = videoFile?.asset?.fileURL || video?.asset?.url

    if (!videoUrl) {
        return null
    }

    return (
        <>
            <div className={s.Video}>
                {video && video?.asset && videoPoster && (
                    <div className={s.VideoPoster} onClick={() => setIsModalOpen(true)}>
                        {Play}
                        <ImageBox image={videoPoster} alt={title || ''} width={500} height={500} />
                    </div>
                )}
                {
                    <div className={s.VideoContent}>
                        <div className={s.VideoTitle}>
                            <div className={s.VideoTitles}>
                                {videoPretitle && <span className={'smallCaps'}>{videoPretitle}</span>}
                                {title && <span className={'smallCaps'}>{title}</span>}
                            </div>
                            {copy && (
                                <div className={s.VideoCopy}>
                                    <Copy copy={copy} />
                                </div>
                            )}
                        </div>
                    </div>
                }
            </div>
            {isModalOpen && (
                <Modal close={() => setIsModalOpen(false)}>
                    <div className={s.Modal}>
                        {videoUrl && <video controls src={videoUrl} ref={videoRef} />}
                    </div>
                </Modal>
            )}
        </>
    )
}

export default VideoSection
